import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Container, Image, Button } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../SignUp/onBoarding/religion.css";
import { showAlert } from "../../../../../utils/alertUtils";

import langIcon from "../../../../../assets/images/lang.png";

import { API_URL } from "../../../../../api";
import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";

export const LanguageUpdate = () => {
  const { getCookie } = useCookies();
  const [allLanguages, setAllLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const navigate = useNavigate();
  const approvalstatus = getCookie("approval");

  useEffect(() => {
    fetch(`${API_URL}customer/users/language`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setAllLanguages(data.languages);
      })
      .catch((error) => {
        console.error("Error fetching languages:", error);
      });

    fetch(`${API_URL}customer/users/userlanguage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSelectedLanguages(
          data.selectedLanguages.map((lang) => lang.language_id)
        );
      })
      .catch((error) => {
        console.error("Error fetching user languages:", error);
      });
  }, []);

  const handleLanguageClick = (languageId) => {
    setSelectedLanguages((prevSelected) => {
      if (prevSelected.includes(languageId)) {
        return prevSelected.filter((id) => id !== languageId);
      } else {
        return [...prevSelected, languageId];
      }
    });
  };

  const handleReligionClick = (e) => {
    e.preventDefault();

    if (selectedLanguages.length === 0) {
      showAlert("", "Please select at least one language.");
      return;
    }

    fetch(`${API_URL}customer/users/language`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify({ languages: selectedLanguages }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (approvalstatus === "PENDING") {
          showAlert(
            "Success",
            "Approval request sent!",
            () => (window.location.href = "/user/home")
          );
        } else {
          showAlert(
            "Success",
            "Successfully updated",
            () => (window.location.href = "/user/home")
          );
        }
      })
      .catch((error) => {
        console.error("Error updating languages:", error);
      });
  };

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",

          padding: "2rem",
        }}
      >
        <div className="religion-container" style={{ overflow: "hidden" }}>
          <Container className="religion-main">
            <Container className="religion-content">
              <Container className="religion-details">
                <div className="your-lang">
                  <Container className="religion-text">
                    <Image
                      className="about-yourself-icon"
                      src={langIcon}
                    ></Image>
                    <p>What is your preferred language?</p>
                  </Container>
                  <Container
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxHeight: "39vh",
                      overflowY: "auto",
                      borderRadius: "8px",
                      padding: "10px",
                      width: "100%",
                      paddingRight: "calc(1.5rem * 0.5)",
                      paddingLeft: "calc(1.5rem * 0.5)",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  >
                    {allLanguages.map((language, index) => (
                      <div
                        key={index}
                        className={`lang-item ${
                          selectedLanguages.includes(language.id)
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleLanguageClick(language.id)}
                      >
                        {language.name}
                      </div>
                    ))}
                  </Container>
                </div>
              </Container>

              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <button
                  className="global-cancel-button"
                  onClick={() => navigate("/updateprofile")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="global-save-button"
                  onClick={handleReligionClick}
                >
                  Save
                </button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
};
